import { render, staticRenderFns } from "./ModalProductReg.vue?vue&type=template&id=f4fb30e4&scoped=true"
import script from "./ModalProductReg.vue?vue&type=script&lang=js"
export * from "./ModalProductReg.vue?vue&type=script&lang=js"
import style0 from "./ModalProductReg.vue?vue&type=style&index=0&id=f4fb30e4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4fb30e4",
  null
  
)

export default component.exports